// extracted by mini-css-extract-plugin
module.exports = {"Sections":"sections_Sections__2Cvj7","Content":"sections_Content__qm3nZ","BaltexH1":"sections_BaltexH1__XB_ie","Section":"sections_Section__8CPP_"};